import * as Yup from 'yup'

import {
  APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE,
  APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE,
} from '../../../RentalPortalApplicant'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { USER_FORM_PHONE_FIELD_MAX_LENGTH } from '../../../User'
import {
  getListingDateValue,
  parseListingFormDate,
} from '../../RentalPortal.utils'

import {
  APPLICANT_FORM_FIELD_NAME_EMAIL,
  APPLICANT_FORM_FIELD_NAME_FIRST_NAME,
  APPLICANT_FORM_FIELD_NAME_LAST_NAME,
  APPLICANT_FORM_FIELD_NAME_LISTING,
  APPLICANT_FORM_FIELD_NAME_MESSAGE,
  APPLICANT_FORM_FIELD_NAME_PHONE,
  APPLICANT_FORM_INITIAL_VALUES,
  APPLICANT_FORM_MESSAGE_FIELD_MAX_LENGTH,
  APPLICANT_FORM_OPEN_DROPDOWN_SELECTOR,
} from './RentalPortalApplicantForm.constants'

export function hasOpenApplicantFormDropdown() {
  return Boolean(document.querySelector(APPLICANT_FORM_OPEN_DROPDOWN_SELECTOR))
}

export function getToApplicantListingSelectItems(t) {
  return items =>
    items.map(listing => ({
      label: getListingUnitLabel({ listing, t }),
      value: listing.id,
    }))
}

export function getApplicantFormValidationSchema(t) {
  return Yup.object({
    [APPLICANT_FORM_FIELD_NAME_EMAIL]: Yup.string()
      .required(true)
      .email(t('Error.EnterValidEmailKey')),
    [APPLICANT_FORM_FIELD_NAME_FIRST_NAME]: Yup.string().required(true),
    [APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE]: Yup.object()
      .nullable()
      .required(true),
    [APPLICANT_FORM_FIELD_NAME_LAST_NAME]: Yup.string().required(true),
    [APPLICANT_FORM_FIELD_NAME_LISTING]: Yup.object().nullable().required(true),
    [APPLICANT_FORM_FIELD_NAME_MESSAGE]: Yup.string()
      .ensure()
      .max(
        APPLICANT_FORM_MESSAGE_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: APPLICANT_FORM_MESSAGE_FIELD_MAX_LENGTH,
        })
      ),
    [APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE]: Yup.date().nullable(),
    [APPLICANT_FORM_FIELD_NAME_PHONE]: Yup.string()
      .nullable()
      .max(
        USER_FORM_PHONE_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', { length: USER_FORM_PHONE_FIELD_MAX_LENGTH })
      ),
  })
}

export function getApplicantFormInitialValues(draftValues) {
  return draftValues
    ? {
        ...APPLICANT_FORM_INITIAL_VALUES,
        ...draftValues,
        [APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE]: parseListingFormDate(
          draftValues[APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE]
        ),
      }
    : APPLICANT_FORM_INITIAL_VALUES
}

export function getApplicantFormPayload(values) {
  return {
    [APPLICANT_FORM_FIELD_NAME_EMAIL]: values[APPLICANT_FORM_FIELD_NAME_EMAIL],
    [APPLICANT_FORM_FIELD_NAME_FIRST_NAME]:
      values[APPLICANT_FORM_FIELD_NAME_FIRST_NAME],
    [APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE]:
      values[APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE].value,
    [APPLICANT_FORM_FIELD_NAME_LAST_NAME]:
      values[APPLICANT_FORM_FIELD_NAME_LAST_NAME],
    [APPLICANT_FORM_FIELD_NAME_LISTING]:
      values[APPLICANT_FORM_FIELD_NAME_LISTING].value,
    [APPLICANT_FORM_FIELD_NAME_MESSAGE]:
      values[APPLICANT_FORM_FIELD_NAME_MESSAGE] || null,
    [APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE]: getListingDateValue(
      values[APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE]
    ),
    [APPLICANT_FORM_FIELD_NAME_PHONE]:
      values[APPLICANT_FORM_FIELD_NAME_PHONE] || null,
  }
}
